// extracted by mini-css-extract-plugin
export default {"card":"TagListings_card__B0MDf"};